/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetSEOResponse
 */
export interface GetSEOResponse {
    /**
     * 
     * @type {string}
     * @memberof GetSEOResponse
     */
    url: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetSEOResponse
     */
    urlEntryExists: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetSEOResponse
     */
    tags?: Array<string>;
}

/**
 * Check if a given object implements the GetSEOResponse interface.
 */
export function instanceOfGetSEOResponse(value: object): value is GetSEOResponse {
    if (!('url' in value) || value['url'] === undefined) return false;
    if (!('urlEntryExists' in value) || value['urlEntryExists'] === undefined) return false;
    return true;
}

export function GetSEOResponseFromJSON(json: any): GetSEOResponse {
    return GetSEOResponseFromJSONTyped(json, false);
}

export function GetSEOResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSEOResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'url': json['url'],
        'urlEntryExists': json['urlEntryExists'],
        'tags': json['tags'] == null ? undefined : json['tags'],
    };
}

export function GetSEOResponseToJSON(json: any): GetSEOResponse {
    return GetSEOResponseToJSONTyped(json, false);
}

export function GetSEOResponseToJSONTyped(value?: GetSEOResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'url': value['url'],
        'urlEntryExists': value['urlEntryExists'],
        'tags': value['tags'],
    };
}

